var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-1"},[_c('el-row',[_vm._v(" "+_vm._s(_vm.title)+" "),_c('el-col',{attrs:{"span":24}},[_c('div',{staticClass:"form-group pt-0.5"},[_c('el-input',{attrs:{"type":"textarea"},model:{value:(_vm.field.description),callback:function ($$v) {_vm.$set(_vm.field, "description", $$v)},expression:"field.description"}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }